module.exports = __webpack_public_path__ + "img/edge_hiver_chien_traineau.373bc941.svg";